import {DomainEvent, createDomainEvent} from './domain-event'

/**
 * Order Domain Events
 *
 * Events related to order lifecycle
 */

// Event Types
export const OrderEventTypes = {
  OrderCreated: 'order.created',
  OrderSubmitted: 'order.submitted',
  OrderPaymentStarted: 'order.payment_started',
  OrderPaymentCompleted: 'order.payment_completed',
  OrderPaymentFailed: 'order.payment_failed',
  OrderCancelled: 'order.cancelled',
  DeliverySelected: 'order.delivery_selected',
  PaymentMethodSelected: 'order.payment_method_selected',
} as const

// Payload Types
export interface OrderCreatedPayload {
  orderId: Id,
  totalAmount: number | string
}

// export interface OrderSubmittedPayload {
//   orderId: string
//   userId?: string
// }
//
// export interface OrderPaymentStartedPayload {
//   orderId: string
//   paymentMethod: string
//   amount: number
// }
//
// export interface OrderPaymentCompletedPayload {
//   orderId: string
//   transactionId?: string
// }
//
// export interface OrderPaymentFailedPayload {
//   orderId: string
//   reason: string
// }
//
// export interface OrderCancelledPayload {
//   orderId: string
//   reason?: string
// }
//
// export interface DeliverySelectedPayload {
//   orderId?: string
//   deliveryServiceId: string
//   deliveryType: string
//   pickupPointId?: string
// }
//
// export interface PaymentMethodSelectedPayload {
//   orderId?: string
//   paymentMethodId: string
//   paymentMethodType: string
// }

// Event Types
export type OrderCreatedEvent = DomainEvent<OrderCreatedPayload>
// export type OrderSubmittedEvent = DomainEvent<OrderSubmittedPayload>
// export type OrderPaymentStartedEvent = DomainEvent<OrderPaymentStartedPayload>
// export type OrderPaymentCompletedEvent = DomainEvent<OrderPaymentCompletedPayload>
// export type OrderPaymentFailedEvent = DomainEvent<OrderPaymentFailedPayload>
// export type OrderCancelledEvent = DomainEvent<OrderCancelledPayload>
// export type DeliverySelectedEvent = DomainEvent<DeliverySelectedPayload>
// export type PaymentMethodSelectedEvent = DomainEvent<PaymentMethodSelectedPayload>

// Event Factories
export const OrderEvents = {
  created(payload: OrderCreatedPayload): OrderCreatedEvent {
    return createDomainEvent(OrderEventTypes.OrderCreated, payload, payload.orderId)
  },

  // submitted(payload: OrderSubmittedPayload): OrderSubmittedEvent {
  //   return createDomainEvent(OrderEventTypes.OrderSubmitted, payload, payload.orderId)
  // },
  //
  // paymentStarted(payload: OrderPaymentStartedPayload): OrderPaymentStartedEvent {
  //   return createDomainEvent(OrderEventTypes.OrderPaymentStarted, payload, payload.orderId)
  // },
  //
  // paymentCompleted(payload: OrderPaymentCompletedPayload): OrderPaymentCompletedEvent {
  //   return createDomainEvent(OrderEventTypes.OrderPaymentCompleted, payload, payload.orderId)
  // },
  //
  // paymentFailed(payload: OrderPaymentFailedPayload): OrderPaymentFailedEvent {
  //   return createDomainEvent(OrderEventTypes.OrderPaymentFailed, payload, payload.orderId)
  // },
  //
  // cancelled(payload: OrderCancelledPayload): OrderCancelledEvent {
  //   return createDomainEvent(OrderEventTypes.OrderCancelled, payload, payload.orderId)
  // },
  //
  // deliverySelected(payload: DeliverySelectedPayload): DeliverySelectedEvent {
  //   return createDomainEvent(OrderEventTypes.DeliverySelected, payload, payload.orderId)
  // },
  //
  // paymentMethodSelected(payload: PaymentMethodSelectedPayload): PaymentMethodSelectedEvent {
  //   return createDomainEvent(OrderEventTypes.PaymentMethodSelected, payload, payload.orderId)
  // },
}
